import { useTitle } from '@vueuse/core';

export function updateTitle(title: string) {
  useTitle(`${title} - ${process.env.APP_NAME}`);
}
